import React from "react";
import { useTrading } from "../context/TradingContext";
import MonthlyLeaderboard from "../components/MonthlyLeaderboard";
import MultiModelEquityCurve from "../components/MultiModelEquityCurve";
import OpenPositions from "../components/OpenPositions";
import RecentTrades from "../components/RecentTrades";

function Dashboard() {
  const { loading, error, systemStatus, openPositions } =
    useTrading();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent-gold"></div>
      </div>
    );
  }

  return (
    <div className="space-y-4 sm:space-y-6">
      {/* Page Header */}
      <div className="flex justify-between items-start">
        <div>
          <h1 className="text-lg sm:text-2xl font-semibold tracking-tight text-dark-text mb-0.5 sm:mb-1">
            Day Trading Leaderboard
          </h1>
          <p className="text-xs sm:text-sm text-dark-text-secondary">
            Same prompt. Same live market data. Same rules. Different AI models. Who makes the best trading decisions?
          </p>
        </div>
      </div>

      {/* Leaderboard */}
      <div className="card">
        <MonthlyLeaderboard />
      </div>

      {/* Open Positions Section - Full Width */}
      <div className="card">
        <div className="card-header">
          <span className="card-title">Open Positions</span>
          <span className="font-mono text-xs px-2 py-1 bg-dark-tertiary rounded text-dark-text-muted">
            {openPositions?.length || 0}
          </span>
        </div>
        <OpenPositions />
      </div>

      {/* Recent Trades Section - Full Width */}
      <div className="card">
        <div className="card-header">
          <span className="card-title">Recent Trades</span>
          <span className="text-xs text-dark-text-muted">Click a trade to see LLM reasoning</span>
        </div>
        <RecentTrades />
      </div>

      {/* Model Performance - Full Width */}
      <div className="card">
        <div className="card-header">
          <span className="card-title">Model Performance</span>
          <span className="text-xs text-dark-text-muted">Balance over time</span>
        </div>
        <div className="p-4">
          <MultiModelEquityCurve period="monthly" />
        </div>
      </div>

      {/* System Info */}
      {systemStatus && (
        <div className="card p-3 sm:p-4 text-[10px] sm:text-xs text-dark-text-muted">
          <div className="flex flex-wrap justify-between gap-2 sm:gap-4">
            <span className="hidden sm:inline">
              Last Decision: {systemStatus.last_decision_time || "N/A"}
            </span>
            <span>Active Models: {systemStatus.active_models}</span>
            <span>Open Positions: {systemStatus.open_positions}</span>
            <span className="hidden md:inline">
              Trading Window: {systemStatus.trading_window?.start} -{" "}
              {systemStatus.trading_window?.end}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
